import { JsonDataframe } from '../../TypeScript/types';

/**
 * Uses a web worker to get a sample of the dataset to use for faster EDA
 * @param dataset
 * @returns a sample of the whole dataset
 */
export const getSampleDataset = (
  dataset: JsonDataframe,
): Promise<JsonDataframe> => {
  return new Promise((resolve, reject) => {
    const worker: Worker = new Worker('/sample-dataset.js');
    worker.onmessage = (event: MessageEvent<JsonDataframe>) => {
      const sample: JsonDataframe = event.data;
      resolve(sample);
      worker.terminate();
    };
    worker.onerror = (ev: ErrorEvent) => {
      reject(ev.error);
      worker.terminate();
    };
    worker.postMessage(dataset);
  });
};
